import { render } from "./serviceLimits.vue?vue&type=template&id=01099a2b&scoped=true"
import script from "./serviceLimits.vue?vue&type=script&lang=js"
export * from "./serviceLimits.vue?vue&type=script&lang=js"

import "./serviceLimits.vue?vue&type=style&index=0&id=01099a2b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01099a2b"]])

export default __exports__